/**
 * Constants definition.
 *
 * @type {{BIG_CLIENT_NEW_CONTRACT: string, BIG_CLIENT_RECONTRACT: string, CONTRACT_SUPPLEMENT: string}}
 */
const BIG_CLIENT_PROCEDURE_TYPE = {
  BIG_CLIENT_NEW_CONTRACT: 'BIG_CLIENT_NEW_CONTRACT',
  BIG_CLIENT_RECONTRACT: 'BIG_CLIENT_RECONTRACT',
  CONTRACT_SUPPLEMENT: 'CONTRACT_SUPPLEMENT',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const BIG_CLIENT_PROCEDURE_TYPE_ENUM = Object.keys(BIG_CLIENT_PROCEDURE_TYPE);

const BIG_CLIENT_NEW_CONTRACT = BIG_CLIENT_PROCEDURE_TYPE_ENUM[0];
const BIG_CLIENT_RECONTRACT = BIG_CLIENT_PROCEDURE_TYPE_ENUM[1];
const CONTRACT_SUPPLEMENT = BIG_CLIENT_PROCEDURE_TYPE_ENUM[2];

export {
  BIG_CLIENT_PROCEDURE_TYPE,
  BIG_CLIENT_NEW_CONTRACT,
  BIG_CLIENT_RECONTRACT,
  CONTRACT_SUPPLEMENT,
  BIG_CLIENT_PROCEDURE_TYPE_ENUM,
};
